<template lang='pug'>
section
  table(class='v-datatable v-table theme--light pays-table')
    thead
      tr
        th(align='left') Дата платежа
        th(align='right') Выкупленная площадь
        th(align='right') Осталось выкупить
        th(align='right') Цена за метр
        th(align='right') Рекомендуемый платеж
        th(align='right') Сумма платежа
    tbody
      template(v-for='(pays, date) in pays')
        tr(:key='date')
          td(colspan='6' class='month-name')
            | {{ date | date('MMMM YYYY') }}
        tr(v-for='pay in pays' :key='pay.day')
          td(class='t-col') {{ pay.day | date }}
          td(class='t-col text-xs-right') {{ pay.redeemedarea }} м<sup>2</sup>
          td(class='t-col text-xs-right') {{ pay.leftarea }} м<sup>2</sup>
          td(class='t-col text-xs-right') {{ pay.currentmetrprice | rubles }}
          td(class='t-col text-xs-right') {{ pay.recommendedpayment | rubles }}
          td(class='t-col text-xs-right') {{ pay.amount_paid | rubles }}
</template>

<script>
export default {
  props: ['payments'],
  computed: {
    pays() {
      return this.payments.reduce((acc, x) => {
        acc[Object.keys(x)] = [].concat(...Object.values(x))
        return acc
      }, {})
    }
  }
}
</script>

<style scoped>
.pays-table >>> td {
  border-top: 0;
  border-bottom: solid 1px #c5c5c5;
}
.month-name {
  color: rgba(0, 0, 0, 0.54);
  text-transform: uppercase;
  background: #fafafa;
  font-weight: 600;
  font-size: 10px;
}
</style>
